import { useAppHotkeys } from './useAppHotkeys';
import { useNavigate, useLocation } from 'react-router-dom';
import { toggleShortcutsModal, toggleSearchModal, ui$ } from '../store';
import { useCompositionTracking } from './useCompositionTracking';

/**
 * Global keyboard shortcuts hook
 * Registers shortcuts that work across the entire app
 */
const useGlobalShortcuts = () => {
  useCompositionTracking();
  const navigate = useNavigate();
  const location = useLocation();

  // "Cmd+K" / "Ctrl+K" - Toggle search modal
  useAppHotkeys('mod+k', (e) => {
    e.preventDefault();
    toggleSearchModal();
  }, {
    allowWhenBlocked: true,
    enableOnContentEditable: true,
    enableOnFormTags: true, // Search should work from anywhere, including input fields
  });

  // "H" - Toggle shortcuts modal (help)
  useAppHotkeys('h', (e) => {
    e.preventDefault();
    toggleShortcutsModal();
  }, {
    allowWhenBlocked: () => ui$.shortcutsModalOpen.get(),
    enableOnFormTags: false, // Don't trigger in input fields
  });

  // "Shift+1" (!) - Go to All articles
  useAppHotkeys(['shift+1', '!'], (e) => {
    e.preventDefault();
    if (location.pathname !== '/all') {
      navigate('/all');
    }
  }, {
    enableOnFormTags: false,
  });

  // "Shift+2" (@) - Go to Inbox
  useAppHotkeys(['shift+2', '@'], (e) => {
    e.preventDefault();
    if (location.pathname !== '/inbox') {
      navigate('/inbox');
    }
  }, {
    enableOnFormTags: false,
  });

  // Dialog owns Escape, focus restoration, and IME-safe dismissal.
};

export default useGlobalShortcuts;
